import { cn } from "@/lib/utils"

interface StepIndicatorProps {
  current: number
  total: number
}

export function StepIndicator({ current, total }: StepIndicatorProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-xs font-semibold text-[#6B7280] tracking-wide">
        שלב {current} מתוך {total}
      </span>
      <div className="flex gap-1.5">
        {Array.from({ length: total }, (_, i) => (
          <span
            key={i}
            className={cn(
              "h-1.5 rounded-full transition-all",
              i + 1 <= current ? "bg-[#1B2D52] w-8" : "bg-[#E5E7EB] w-4",
            )}
          />
        ))}
      </div>
    </div>
  )
}
